module.exports = __webpack_public_path__ + "media/images/srfLogo-88323cbda157666feff3207916862799.png";